module.exports = __webpack_public_path__ + "img/hauskraeutchesgarten_3.38aa73bb.jpg";